import React, {useEffect, useState} from "react"
import Loader from "../common/PageLoader";
import logo from "../../media/branding/logo.png";
import {Helmet} from "react-helmet";
import Navbar from "../navigation/Navbar";
import { mainGet, mainPost } from "../../domain/net/mainApi";
/* eslint-disable react-hooks/exhaustive-deps */

// Кеш для аналитики
const analyticsCache = new Map();

const getCacheKey = (userId, role, period) => `${userId}_${role}_${period}`;

const fetchAnalyticsWithCache = async (params, cacheKey) => {
	if (analyticsCache.has(cacheKey)) {
		const cached = analyticsCache.get(cacheKey);
		if (Date.now() - cached.timestamp < 5 * 60 * 1000) {
			return cached.data;
		}
	}

	const response = await mainGet(params);
	if (response.data.ok) {
		const cacheData = {
			data: response.data,
			timestamp: Date.now()
		};
		analyticsCache.set(cacheKey, cacheData);
	}
	return response.data;
};

export default function StudentAnalytics() {
	const [user, setUser] = useState({})
	const [analyticsData, setAnalyticsData] = useState()
	const [classesChartData, setClassesChartData] = useState([])
	const [incomeChartData, setIncomeChartData] = useState([])
	const [efficiencyChartData, setEfficiencyChartData] = useState([])
	const [isStudent, setIsStudent] = useState(true)
	const [comparisonPeriod, setComparisonPeriod] = useState(5)

	function getMonthName(monthNumber) {
		const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
		if (typeof monthNumber === 'string' && monthNumber.includes('-')) {
			const [year, month] = monthNumber.split('-');
			const monthNum = parseInt(month, 10);
			if (Number.isNaN(monthNum) || monthNum < 1 || monthNum > 12) return monthNumber;
			return `${months[monthNum - 1]} ${year}`;
		}
		const monthNum = parseInt(monthNumber, 10);
		return months[monthNum - 1] || monthNumber;
	}

	async function getall_() {
		let clid = localStorage.getItem('clid')
		let key = localStorage.getItem('key')
		const re = await mainGet({ type: 'checkuser', id: clid, pass: key })
		if (re.data.ok) {
			const userData = JSON.parse(JSON.stringify(re.data.data))
			setUser(userData)
			setIsStudent(userData.role === 'student')
		}
	}

	// Modern Bar Chart Component
	const ModernBarChart = ({ data, height = 300, color = "#3b82f6", title, isCurrency = false }) => {
		if (!data || !data.length) return (
			<div className="chart-container">
				<div className="no-data">Нет данных для отображения</div>
			</div>
		);

		const maxValue = Math.max(...data.map(d => Number(d.y) || 0));
		const barWidth = Math.max(30, 400 / data.length);
		const spacing = Math.max(10, 200 / data.length);
		const chartWidth = Math.max(760, data.length * (barWidth + spacing) + 40);

		return (
			<div className="chart-container">
				{title && <h4 className="chart-title">{title}</h4>}
				<div className="chart-wrapper">
					<svg
						width="100%"
						height={height}
						viewBox={`0 0 ${chartWidth} ${height}`}
						className="bar-chart"
						preserveAspectRatio="none"
					>
						{[0, 0.25, 0.5, 0.75, 1].map((ratio, i) => (
							<line
								key={i}
								x1="40"
								y1={height - 60 - (height - 80) * ratio}
								x2={chartWidth}
								y2={height - 60 - (height - 80) * ratio}
								className="grid-line"
							/>
						))}

						{data.map((item, index) => {
							const barHeight = ((Number(item.y) || 0) / maxValue) * (height - 80);
							const x = 40 + index * (barWidth + spacing);
							const y = height - 60 - barHeight;

							return (
								<g key={index} className="bar-group">
									<rect
										x={x}
										y={y}
										width={barWidth}
										height={barHeight}
										rx="6"
										className="bar"
										style={{ fill: color }}
									/>
									<text
										x={x + barWidth / 2}
										y={y - 8}
										textAnchor="middle"
										className="bar-value"
									>
										{isCurrency ? `${item.y} ₽` : item.y}
									</text>
									<text
										x={x + barWidth / 2}
										y={height - 30}
										textAnchor="middle"
										className="bar-label"
									>
										{item.x}
									</text>
								</g>
							);
						})}

						{[0, 0.25, 0.5, 0.75, 1].map((ratio, i) => (
							<text
								key={i}
								x="30"
								y={height - 60 - (height - 80) * ratio}
								textAnchor="end"
								className="axis-label"
							>
								{isCurrency ? `${Math.round(maxValue * ratio)} ₽` : Math.round(maxValue * ratio)}
							</text>
						))}
					</svg>
				</div>
			</div>
		);
	};

	// Line Chart Component
	const LineChart = ({ data, height = 200, color = "#3b82f6", title }) => {
		if (!data || !data.length) return (
			<div className="chart-container">
				<div className="no-data">Нет данных для отображения</div>
			</div>
		);

		const values = data.map(d => Number(d.y) || 0);
		const maxValue = Math.max(...values);
		const minValue = Math.min(...values);
		const range = maxValue - minValue || 1;

		const chartWidth = Math.max(760, data.length * 90);
		const padding = 40;

		return (
			<div className="chart-container">
				{title && <h4 className="chart-title">{title}</h4>}
				<div className="chart-wrapper">
					<svg
						width="100%"
						height={height}
						viewBox={`0 0 ${chartWidth} ${height}`}
						className="line-chart"
						preserveAspectRatio="none"
					>
						{[0, 0.25, 0.5, 0.75, 1].map((ratio, i) => (
							<line
								key={i}
								x1={padding}
								y1={padding + (height - padding * 2) * ratio}
								x2={chartWidth - padding}
								y2={padding + (height - padding * 2) * ratio}
								className="grid-line"
							/>
						))}

						<path
							d={data.map((point, index) => {
								const x = padding + (index / (data.length - 1)) * (chartWidth - padding * 2);
								const y = padding + (height - padding * 2) * (1 - ((point.y - minValue) / range));
								return `${index === 0 ? 'M' : 'L'} ${x} ${y}`;
							}).join(' ')}
							fill="none"
							stroke={color}
							strokeWidth="3"
							className="line-path"
						/>

						{data.map((point, index) => {
							const x = padding + (index / (data.length - 1)) * (chartWidth - padding * 2);
							const y = padding + (height - padding * 2) * (1 - ((point.y - minValue) / range));

							return (
								<g key={index}>
									<circle
										cx={x}
										cy={y}
										r="4"
										fill={color}
										className="data-point"
									/>
									<text
										x={x}
										y={y - 10}
										textAnchor="middle"
										className="point-value"
									>
										{point.y}%
									</text>
									<text
										x={x}
										y={height - 10}
										textAnchor="middle"
										className="point-label"
									>
										{point.x}
									</text>
								</g>
							);
						})}
					</svg>
				</div>
			</div>
		);
	};

	// Modern Donut Chart Component
	const ModernDonutChart = ({ completed, remaining, total, title }) => {
		const completedValue = Number(completed) || 0;
		const remainingValue = Number(remaining) || 0;
		const totalValue = Math.max(total || completedValue + remainingValue, 1);
		const completedPercent = (completedValue / totalValue) * 100;
		const circumference = 2 * Math.PI * 40;
		const strokeDasharray = `${(completedPercent / 100) * circumference} ${circumference}`;

		return (
			<div className="donut-chart-container">
				{title && <h4 className="chart-title">{title}</h4>}
				<div className="donut-chart">
					<svg width="120" height="120" viewBox="0 0 120 120">
						<circle
							cx="60"
							cy="60"
							r="40"
							fill="none"
							stroke="#e5e7eb"
							strokeWidth="8"
						/>
						<circle
							cx="60"
							cy="60"
							r="40"
							fill="none"
							stroke="#10b981"
							strokeWidth="8"
							strokeDasharray={strokeDasharray}
							strokeLinecap="round"
							transform="rotate(-90 60 60)"
						/>
						<text
							x="60"
							y="60"
							textAnchor="middle"
							dy="4"
							className="donut-percent"
						>
							{Math.round(completedPercent)}%
						</text>
					</svg>
				</div>
				<div className="donut-legend">
					<div className="legend-item">
						<span className="legend-color completed"></span>
						<span className="legend-text">Пройдено: {completedValue}</span>
					</div>
					<div className="legend-item">
						<span className="legend-color remaining"></span>
						<span className="legend-text">Осталось: {remainingValue}</span>
					</div>
				</div>
			</div>
		);
	};

	// KPI Card Component
	const KPICard = ({ title, value, subtitle, trend, color = "#3b82f6" }) => (
		<div className="kpi-card">
			<div className="kpi-title">{title}</div>
			<div className="kpi-main-row">
				<div className="kpi-value" style={{ color }}>{value}</div>
				{trend !== undefined && trend !== null && (
					<div className={`kpi-trend ${trend > 0 ? 'positive' : trend < 0 ? 'negative' : 'neutral'}`}>
						{trend > 0 ? '↗' : trend < 0 ? '↘' : '→'} {Math.abs(trend)}%
					</div>
				)}
			</div>
			{subtitle && <div className="kpi-subtitle">{subtitle}</div>}
		</div>
	);

	// Function to get analytics based on user role
	async function getAnalytics() {
		const d = new Date();
		d.setMonth(d.getMonth() - comparisonPeriod + 1);
		const month = d.getMonth() + 1;
		const leastD = `${d.getFullYear()}-${month < 10 ? `0${month}` : month}-01`;
		const now = new Date();
		const currentMonth = now.getMonth() + 1;
		const currentMonthKey = `${now.getFullYear()}-${String(currentMonth).padStart(2, '0')}`;
		const cacheKey = getCacheKey(localStorage.getItem('clid'), user.role, comparisonPeriod);

		try {
			let response;

			if (isStudent) {
				response = await fetchAnalyticsWithCache(
					{
						type: 'getAnalyticsForStudent',
						id: localStorage.getItem('clid'),
						dateLeast: leastD
					},
					cacheKey
				);
				if (response.ok) {
					setAnalyticsData(response.data);
					let finalArrayCl = [];
					Object.keys(response.data.cl)
						.sort((a, b) => a.localeCompare(b))
						.forEach(function (key) {
						finalArrayCl.push({
							x: getMonthName(key),
							y: response.data.cl[key]
						});
					});
					setClassesChartData(finalArrayCl);
				}
			} else {
				const postResponse = await mainPost({
					type: 'getAnalytics',
					currentMonth,
					currentMonthKey,
					id: localStorage.getItem('clid'),
					coachN: user.name + " " + user.sname,
					role: user.role,
					leastD
				});
				response = postResponse.data;

				if (response.ok) {
					setAnalyticsData(response);

					// Classes data
					let finalArrayCl = [];
					if (response.advanced && response.advanced.cl) {
						const sortedMonths = Object.keys(response.advanced.cl).sort((a, b) => a.localeCompare(b));
						sortedMonths.forEach(function (key) {
							finalArrayCl.push({
								x: getMonthName(key),
								y: response.advanced.cl[key]
							});
						});
					}
					setClassesChartData(finalArrayCl);

					// Income data
					let finalArrayIncome = [];
					if (response.advanced && response.advanced.incM) {
						const sortedMonths = Object.keys(response.advanced.incM).sort((a, b) => a.localeCompare(b));
						sortedMonths.forEach(function (key) {
							finalArrayIncome.push({
								x: getMonthName(key),
								y: response.advanced.incM[key]
							});
						});
					}
					setIncomeChartData(finalArrayIncome);

					// Efficiency data - передаем response
					calculateEfficiencyData(response);
				}
			}
		} catch (error) {
			console.error('Error fetching analytics:', error);
		}
	}

	// Helper functions
	const getTotalClassesThisMonth = () => {
		if (!isStudent && analyticsData?.advanced?.cl) {
			const now = new Date();
			const currentMonth = (now.getMonth() + 1).toString().padStart(2, '0');
			const currentMonthKey = `${now.getFullYear()}-${currentMonth}`;
			return analyticsData.advanced.cl[currentMonthKey] ?? analyticsData.advanced.cl[currentMonth] ?? 0;
		}
		return analyticsData?.tpc || 0;
	};

	const getCompletedClasses = () => {
		if (isStudent) {
			return (analyticsData?.tpc || 0) - (analyticsData?.clRem || 0);
		} else {
			return getTotalClassesThisMonth();
		}
	};

	const getRemainingClasses = () => {
		if (isStudent) {
			return analyticsData?.clRem || 0;
		} else {
			return 0;
		}
	};

	const getRemainingClassesText = () => {
		if (isStudent) {
			const remaining = getRemainingClasses();
			return remaining > 0 ? `осталось ${remaining}` : 'все пройдено!';
		}
		return '';
	};

	const getCurrentMonthIncome = () => {
		if (!isStudent && analyticsData?.advanced?.incM) {
			const now = new Date();
			const currentMonth = (now.getMonth() + 1).toString().padStart(2, '0');
			const currentMonthKey = `${now.getFullYear()}-${currentMonth}`;
			return analyticsData.advanced.incM[currentMonthKey] ?? analyticsData.advanced.incM[currentMonth] ?? 0;
		}
		return 0;
	};

	const getCurrentMonthNewStudents = () => {
		if (!isStudent && analyticsData?.advanced?.su) {
			const now = new Date();
			const currentMonth = (now.getMonth() + 1).toString().padStart(2, '0');
			const currentMonthKey = `${now.getFullYear()}-${currentMonth}`;
			return analyticsData.advanced.su[currentMonthKey] ?? analyticsData.advanced.su[currentMonth] ?? 0;
		}
		return analyticsData?.tps || 0;
	};

	const getTotalStudentsAllTime = () => {
		if (!isStudent) return analyticsData?.aps || 0;
		return 0;
	}

	const getIncomeTrend = () => {
		if (!isStudent && incomeChartData.length >= 2) {
			const currentIncome = getCurrentMonthIncome();
			const previousIncomes = incomeChartData.slice(0, -1).map(item => item.y);
			const averagePrevious = previousIncomes.reduce((a, b) => a + b, 0) / previousIncomes.length;

			if (averagePrevious > 0) {
				return Math.round(((currentIncome - averagePrevious) / averagePrevious) * 100);
			}
		}
		return 0;
	};

	const getClassesTrend = () => {
		if (!isStudent && classesChartData.length >= 2) {
			const currentClasses = getTotalClassesThisMonth();
			const previousClasses = classesChartData.slice(0, -1).map(item => item.y);
			const averagePrevious = previousClasses.reduce((a, b) => a + b, 0) / previousClasses.length;

			if (averagePrevious > 0) {
				return Math.round(((currentClasses - averagePrevious) / averagePrevious) * 100);
			}
		}
		return 0;
	};

	const getUpcomingIncome = () => {
		if (!isStudent && analyticsData?.advanced?.incUpc) {
			return analyticsData.advanced.incUpc;
		}
		return 0;
	};

	const calculateEfficiencyData = (data = analyticsData) => {
		if (!isStudent && data?.advanced?.cl) {
			const monthlyClasses = data.advanced.cl;
			const sortedMonths = Object.keys(monthlyClasses).sort((a, b) => a.localeCompare(b));

			const efficiencyData = sortedMonths.map((month, index, array) => {
				const currentClasses = monthlyClasses[month];

				// Берем предыдущие n месяцев (исключая текущий)
				const previousMonths = array.slice(0, index); // все месяцы до текущего
				const monthsToCompare = Math.min(comparisonPeriod - 1, previousMonths.length);

				if (monthsToCompare === 0) {
					return { x: getMonthName(month), y: 100 }; // нет данных для сравнения
				}

				const recentMonths = previousMonths.slice(-monthsToCompare);
				const totalPrevious = recentMonths.reduce((sum, m) => sum + (monthlyClasses[m] || 0), 0);
				const averagePrevious = totalPrevious / monthsToCompare;

				// Эффективность = (текущий месяц / среднее за предыдущие n месяцев) * 100
				const efficiency = averagePrevious > 0 ? Math.round((currentClasses / averagePrevious) * 100) : 100;

				return { x: getMonthName(month), y: efficiency };
			});

			setEfficiencyChartData(efficiencyData);
		}
	};

	const getCurrentEfficiency = () => {
		if (!isStudent && analyticsData?.advanced?.cl) {
			const monthlyClasses = analyticsData.advanced.cl;
			const sortedMonths = Object.keys(monthlyClasses).sort((a, b) => a.localeCompare(b));

			const currentMonthIndex = sortedMonths.length - 1;
			if (currentMonthIndex < 0) return 100;

			const currentMonth = sortedMonths[currentMonthIndex];
			const currentClasses = monthlyClasses[currentMonth];

			// Берем предыдущие n месяцев
			const previousMonths = sortedMonths.slice(0, currentMonthIndex);
			const monthsToCompare = Math.min(comparisonPeriod - 1, previousMonths.length);

			if (monthsToCompare === 0) return 100;

			const recentMonths = previousMonths.slice(-monthsToCompare);
			const totalPrevious = recentMonths.reduce((sum, m) => sum + (monthlyClasses[m] || 0), 0);
			const averagePrevious = totalPrevious / monthsToCompare;

			return averagePrevious > 0 ? Math.round((currentClasses / averagePrevious) * 100) : 100;
		}
		return 100;
	};

	useEffect(() => {
		if (user.name) {
			getAnalytics();
		}
	}, [user, comparisonPeriod]);

	useEffect(() => {
		getall_();
	}, []);

	// Добавь этот эффект для пересчета эффективности при изменении периода
	useEffect(() => {
		if (analyticsData && !isStudent) {
			calculateEfficiencyData();
		}
	}, [comparisonPeriod, analyticsData]);

	if (!user.name || !analyticsData) {
		return <Loader/>;
	}

	const getRoleTitle = () => {
		const titles = {
			'admin': 'Администратор',
			'Sysadmin': 'Системный администратор',
			'student': 'Ученица',
			'coach': 'Тренер'
		};
		return titles[user.role] || user.role;
	};

	return (
		<div className="analytics-app">
			<Helmet>
				<title>Аналитика</title>
				<link rel="shortcut icon" href={logo}/>
			</Helmet>

			<div className="analytics-background">
				<div className="background-overlay"></div>
			</div>

			<div className="analytics-container">
				<header className="analytics-header">
					<div className="user-info">
						<h1 className="user-name">{user.name} {user.sname}</h1>
						<p className="page-title">Аналитика {getRoleTitle()}</p>
					</div>
					<div className="header-stats">
						<div className="stat-badge">
							<span className="stat-label">Период анализа</span>
							<span className="stat-value">{comparisonPeriod} месяцев</span>
						</div>
					</div>
				</header>

				{/* Period Selector */}
				<section className="period-section">
					<div className="period-selector">
						<label className="period-label">
							Период сравнения: <span className="period-value">{comparisonPeriod} месяцев</span>
						</label>
						<input
							type="range"
							min="2"
							max="10"
							value={comparisonPeriod}
							onChange={(e) => setComparisonPeriod(parseInt(e.target.value))}
							className="period-slider"
						/>
						<div className="period-labels">
							<span>2 мес</span>
							<span>10 мес</span>
						</div>
					</div>
				</section>

				{/* KPI Section */}
				<section className="kpi-section">
					<div className="kpi-grid">
						<KPICard
							title={isStudent ? "Всего занятий" : "Проведено занятий"}
							value={isStudent ? (analyticsData.alTimeCl || 0) : getTotalClassesThisMonth()}
							subtitle={isStudent ? `За всё время, ${getRemainingClassesText()}` : "За этот месяц"}
							trend={!isStudent ? getClassesTrend() : null}
							color="#3b82f6"
						/>
						<KPICard
							title={isStudent ? "Пройдено занятий" : "Получено доходов"}
							value={isStudent ? getCompletedClasses() : `${getCurrentMonthIncome()} ₽`}
							subtitle={isStudent ? `из ${analyticsData.tpc} запланированных` : `предстоящий: ${getUpcomingIncome()} ₽`}
							color="#10b981"
						/>
						{isStudent ? (
							<KPICard
								title="Пропущено занятий"
								value={analyticsData.skippedClasses || 0}
								subtitle={`${analyticsData.tpSkippedClasses || 0} в этом месяце`}
								color="#ef4444"
							/>
						) : (
							<KPICard
								title="Новые ученики за месяц"
								value={getCurrentMonthNewStudents()}
								subtitle={`всего: ${getTotalStudentsAllTime()}`}
								color="#8b5cf6"
							/>
						)}
						{!isStudent && (<KPICard
							title="Рост доходов"
							value={`${analyticsData.tpi || 0} ₽`}
							subtitle="За текущий месяц"
							trend={getIncomeTrend()}
							color="#8b5cf6"
						/>)}
						<KPICard
							title="Эффективность"
							value={`${getCurrentEfficiency()}%`}
							subtitle={`относительно ${comparisonPeriod} месяцев`}
							trend={getCurrentEfficiency() - 100}
							color="#8b5cf6"
						/>
					</div>
				</section>

				{/* Charts Section */}
				<section className="charts-section">
					<div className="charts-grid">
						{/* Monthly Progress for Students */}
						{isStudent && (
							<div className="chart-card">
								<ModernDonutChart
									completed={getCompletedClasses()}
									remaining={getRemainingClasses()}
									total={analyticsData.tpc}
									title="Прогресс за месяц"
								/>
							</div>
						)}

						{/* Classes Chart */}
						<div className={`chart-card ${isStudent ? '' : 'wide'}`}>
							<ModernBarChart
								data={classesChartData}
								height={280}
								color={isStudent ? "#3b82f6" : "#10b981"}
								title={isStudent ? "Занятия по месяцам" : "Занятия проведено по месяцам"}
							/>
						</div>

						{/* Income Chart for Coaches/Admins */}
						{!isStudent && (
							<div className="chart-card wide">
								<ModernBarChart
									data={incomeChartData}
									height={280}
									color="#f59e0b"
									title="Доходы по месяцам"
									isCurrency={true}
								/>
							</div>
						)}

						{/* Efficiency Chart for Coaches/Admins */}
						{!isStudent && efficiencyChartData.length > 0 && (
							<div className="chart-card wide">
								<LineChart
									data={efficiencyChartData}
									height={200}
									color="#8b5cf6"
									title={`Эффективность (%) за ${comparisonPeriod} месяцев`}
								/>
							</div>
						)}

						{/* Additional Stats */}
						<div className="chart-card">
							<div className="stats-list">
								<h4 className="chart-title">Общая статистика</h4>
								{isStudent ? (
									<>
										<div className="stat-item">
											<span className="stat-name">Дата регистрации:</span>
											<span className="stat-value">
                                                {analyticsData.dateReg?.split('-')[2]}.
												{analyticsData.dateReg?.split('-')[1]}.
												{analyticsData.dateReg?.split('-')[0]}
                                            </span>
										</div>
										<div className="stat-item">
											<span className="stat-name">Суммарное время:</span>
											<span className="stat-value">
                                                {analyticsData.allTime?.split('.')[0]} ч {
												analyticsData.allTime?.split('.')[1]} мин
                                            </span>
										</div>
									</>
								) : (
									<>
										<div className="stat-item">
											<span className="stat-name">Учеников за все время:</span>
											<span className="stat-value">{getTotalStudentsAllTime()}</span>
										</div>
										<div className="stat-item">
											<span className="stat-name">Учеников в этом месяце:</span>
											<span className="stat-value">{getCurrentMonthNewStudents()}</span>
										</div>
									</>
								)}
								<div className="stat-item">
									<span className="stat-name">Текущий месяц:</span>
									<span className="stat-value">
                                        {new Date().toLocaleString('ru-RU', { month: 'long', year: 'numeric' })}
                                    </span>
								</div>
								<div className="stat-item">
									<span className="stat-name">Анализ за:</span>
									<span className="stat-value">{comparisonPeriod} месяцев</span>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>

			<Navbar usertype={user.role} fixedT={user.fixed_trainer}/>

			<style jsx>{`
				.analytics-app {
					min-height: 100vh;
					position: relative;
				}

				.analytics-background {
					position: fixed;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
					z-index: -2;
				}

				.background-overlay {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				}

				.analytics-container {
					max-width: 900px;
					margin: 0 auto;
					padding: 20px;
					position: relative;
					z-index: 1;
				}

				.analytics-header {
					background: rgba(255, 255, 255, 0.95);
					backdrop-filter: blur(10px);
					border-radius: 20px;
					padding: 30px;
					margin-bottom: 24px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
					border: 1px solid rgba(255, 255, 255, 0.2);
				}

				.user-info {
					flex: 1;
				}

				.user-name {
					font-size: 2rem;
					font-weight: 700;
					color: #1f2937;
					margin: 0 0 8px 0;
				}

				.page-title {
					font-size: 1.25rem;
					color: #6b7280;
					margin: 0;
					font-weight: 500;
				}

				.header-stats {
					display: flex;
					gap: 16px;
				}

				.stat-badge {
					background: linear-gradient(135deg, #3b82f6, #1d4ed8);
					color: white;
					padding: 12px 20px;
					border-radius: 12px;
					text-align: center;
					min-width: 140px;
				}

				.stat-label {
					display: block;
					font-size: 0.875rem;
					opacity: 0.9;
					margin-bottom: 4px;
				}

				.stat-value {
					display: block;
					font-size: 1.25rem;
					font-weight: 700;
				}

				/* Period Selector */
				.period-section {
					background: rgba(255, 255, 255, 0.95);
					backdrop-filter: blur(10px);
					border-radius: 16px;
					padding: 24px;
					margin-bottom: 24px;
					box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
					border: 1px solid rgba(255, 255, 255, 0.3);
				}

				.period-selector {
					text-align: center;
				}

				.period-label {
					display: block;
					font-size: 1.125rem;
					font-weight: 600;
					color: #1f2937;
					margin-bottom: 16px;
				}

				.period-value {
					color: #3b82f6;
					font-weight: 700;
				}

				.period-slider {
					width: 100%;
					height: 6px;
					border-radius: 3px;
					background: #e5e7eb;
					outline: none;
					margin-bottom: 8px;
				}

				.period-slider::-webkit-slider-thumb {
					appearance: none;
					width: 20px;
					height: 20px;
					border-radius: 50%;
					background: #3b82f6;
					cursor: pointer;
					box-shadow: 0 2px 6px rgba(59, 130, 246, 0.4);
				}

				.period-labels {
					display: flex;
					justify-content: space-between;
					font-size: 0.875rem;
					color: #6b7280;
				}

				/* KPI Section */
				.kpi-section {
					margin-bottom: 24px;
				}

				.kpi-grid {
					display: grid;
					grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
					gap: 16px;
				}

				.kpi-card {
					background: rgba(255, 255, 255, 0.95);
					backdrop-filter: blur(10px);
					border-radius: 16px;
					padding: 18px 20px;
					box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
					border: 1px solid rgba(255, 255, 255, 0.3);
					transition: transform 0.2s ease, box-shadow 0.2s ease;
					display: flex;
					flex-direction: column;
					gap: 10px;
					min-height: 132px;
				}

				.kpi-main-row {
					display: flex;
					align-items: flex-end;
					justify-content: space-between;
					gap: 8px;
					flex-wrap: wrap;
				}

				.kpi-card:hover {
					transform: translateY(-4px);
					box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
				}

				.kpi-title {
					font-size: 0.82rem;
					color: #6b7280;
					margin: 0;
					font-weight: 500;
					line-height: 1.35;
				}

				.kpi-value {
					font-size: clamp(1.6rem, 3vw, 2rem);
					font-weight: 700;
					margin: 0;
					line-height: 1.05;
				}

				.kpi-subtitle {
					font-size: 0.82rem;
					color: #9ca3af;
					line-height: 1.35;
				}

				.kpi-trend {
					font-size: 0.78rem;
					font-weight: 600;
					margin-top: 0;
					padding: 4px 8px;
					border-radius: 999px;
					background: #f3f4f6;
				}

				.kpi-trend.positive {
					color: #10b981;
					background: rgba(16, 185, 129, 0.12);
				}

				.kpi-trend.negative {
					color: #ef4444;
					background: rgba(239, 68, 68, 0.12);
				}

				.kpi-trend.neutral {
					color: #6b7280;
				}

				/* Charts Section */
				.charts-section {
					margin-bottom: 24px;
				}

				.charts-grid {
					display: grid;
					grid-template-columns: ${isStudent ? '1fr 2fr 1fr' : '1fr 1fr'};
					gap: 20px;
				}

				@media (max-width: 1024px) {
					.charts-grid {
						grid-template-columns: 1fr;
					}
				}

				.chart-card {
					background: rgba(255, 255, 255, 0.95);
					backdrop-filter: blur(10px);
					border-radius: 16px;
					padding: 20px;
					box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
					border: 1px solid rgba(255, 255, 255, 0.3);
					display: flex;
					flex-direction: column;
				}

				.chart-card.wide {
					grid-column: span 2;
				}

				@media (max-width: 1024px) {
					.chart-card.wide {
						grid-column: span 1;
					}
				}

				.chart-title {
					font-size: 1.125rem;
					font-weight: 600;
					color: #1f2937;
					margin: 0 0 20px 0;
					text-align: center;
				}

				/* Chart Components */
				.chart-container {
					width: 100%;
					max-width: 100%;
				}

				.chart-wrapper {
					width: 100%;
					overflow-x: hidden;
					overflow-y: hidden;
					display: flex;
					align-items: stretch;
				}

				.bar-chart, .line-chart {
					display: block;
					width: 100%;
					flex: 1;
				}

				.grid-line {
					stroke: #f3f4f6;
					stroke-width: 1;
				}

				.bar {
					transition: all 0.3s ease;
					opacity: 0.8;
				}

				.bar:hover {
					opacity: 1;
					transform: scale(1.05);
				}

				.bar-value, .point-value {
					font-size: 12px;
					font-weight: 600;
					fill: #374151;
				}

				.bar-label, .point-label {
					font-size: 12px;
					fill: #6b7280;
				}

				.axis-label {
					font-size: 11px;
					fill: #9ca3af;
				}

				/* Line Chart */
				.line-path {
					transition: all 0.3s ease;
				}

				.data-point {
					transition: all 0.3s ease;
					cursor: pointer;
				}

				.data-point:hover {
					r: 6;
					fill: #1d4ed8;
				}

				/* Donut Chart */
				.donut-chart-container {
					text-align: center;
				}

				.donut-chart {
					display: inline-block;
					margin-bottom: 16px;
				}

				.donut-percent {
					font-size: 16px;
					font-weight: 700;
					fill: #1f2937;
				}

				.donut-legend {
					display: flex;
					justify-content: center;
					gap: 20px;
					flex-wrap: wrap;
				}

				.legend-item {
					display: flex;
					align-items: center;
					gap: 8px;
				}

				.legend-color {
					width: 12px;
					height: 12px;
					border-radius: 2px;
				}

				.legend-color.completed {
					background: #10b981;
				}

				.legend-color.remaining {
					background: #e5e7eb;
				}

				.legend-text {
					font-size: 0.875rem;
					color: #6b7280;
				}

				/* Stats List */
				.stats-list {
					display: flex;
					flex-direction: column;
					gap: 16px;
				}

				.stat-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 12px 0;
					border-bottom: 1px solid #f3f4f6;
				}

				.stat-item:last-child {
					border-bottom: none;
				}

				.stat-name {
					font-size: 0.875rem;
					color: #6b7280;
				}

				.stat-value {
					font-size: 0.875rem;
					font-weight: 600;
					color: #1f2937;
				}

				/* No Data State */
				.no-data {
					text-align: center;
					color: #9ca3af;
					font-style: italic;
					padding: 40px 20px;
				}

				@media (max-width: 768px) {
					.analytics-container {
						padding: 16px;
					}

					.analytics-header {
						padding: 20px;
						flex-direction: column;
						gap: 16px;
						text-align: center;
					}

					.user-name {
						font-size: 1.5rem;
					}

					.kpi-grid {
						grid-template-columns: 1fr;
					}

					.charts-grid {
						gap: 16px;
					}

					.chart-card {
						padding: 16px;
					}
				}
			`}</style>
		</div>
	)
}